import { useEffect } from 'react';
import {
    THERMAL_PAGE_HEIGHT_CSS,
    THERMAL_PAGE_WIDTH_CSS,
} from './thermalPrintConstants';

const STYLE_ID = 'packing-slip-thermal-page-rules';

/**
 * Injects @page size only while Packing Slip / Shipping Label print views are mounted.
 * Must NOT live in a shared SCSS file: that CSS is bundled with all public routes (including Pick List),
 * and @page is global — it would shrink every print preview to label size.
 */
export function usePackingSlipThermalPageStyle(): void {
    useEffect(() => {
        const el = document.createElement('style');
        el.id = STYLE_ID;
        el.setAttribute('data-peel-print-page', '1');
        el.textContent = `
@media print {
  @page {
    size: ${THERMAL_PAGE_WIDTH_CSS} ${THERMAL_PAGE_HEIGHT_CSS};
    margin: 0;
  }
}
`;
        document.head.appendChild(el);
        return () => {
            el.remove();
        };
    }, []);
}
